import 'core-js/features/object/from-entries';
import Head from 'next/head';
import { AppProps } from 'next/app';
import { ChakraProvider } from '@chakra-ui/react';

import { getTheme } from '@/uikit/theme';
import Favicon from '@/uikit/component/Favicon';
import { ReactQueryProvider } from '@/ui/layout/ReactQueryProvider';
import { LayoutModal } from '@/ui/layout/dynamic';

import 'focus-visible/dist/focus-visible';

const theme = getTheme();

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ChakraProvider resetCSS theme={theme}>
      <ReactQueryProvider>
        <Head>
          <title>File Uploader</title>
          <meta
            name="viewport"
            content="width=device-width, minimum-scale=1, initial-scale=1"
          />
        </Head>
        <Favicon />
        <Component {...pageProps} />
        <LayoutModal />
      </ReactQueryProvider>
    </ChakraProvider>
  );
}

export default MyApp;
